module.exports = __webpack_public_path__ + "img/car.9b1aac91.png";